<template>
    <div>
        <div class="dabox" v-if="showSecond">
            <div class="leftbox">
                <Card class="buttonCss" dis-hover :bordered="false">
                    <Button class="operationBtn" @click="backOut">返回</Button>
                </Card>
            </div>
            <div class="right-box">
                <!-- <div v-if="img_list.length > 0">
                    <div v-for="item in img_list" class="bg-img" :key="item">
                        <img :src="item + '?v=' + timer">
                    </div>
                </div> -->
                <!-- 内容显示 -->
                <div style="flex-grow:1;background: #f7f7f7; position: relative">
                    <div style="position: absolute;left:50%;margin-left:-270px;width: 800px;word-break: break-all;">
                        <div ref="pronbit">
                            <div v-if="components_arr.length > 0">
                                <div v-for="(item, index) in components_arr" :key="index">
                                    <div :class="'component-box ' + (item.tem_type == 1 ? 'partya' : 'partyb')"
                                        :style="'left:' + item.position_x + 'px;top:' + item.position_y + 'px;position: absolute;z-index: 90;width: ' + item.width + 'px;height:' + item.height + 'px;margin: 10px;padding:0 5px;overflow: hidden;'">
                                        <div
                                            :style="'display:flex;line-height:' + item.height + 'px;font-size:' + (item.font_size - 20) + 'px'">
                                            {{ item.title }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(item, index) in img_list" :key="index" class="bg-img" id="tlinK">
                                <img :src="item + '?v=' + timer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var that;
import { getpdf } from '../../api/interFace'

export default {
    name: 'allcontracts',
    props: {
        titleSync: Object
    },
    data() {
        return {
            data: {},
            list: [],
            components_arr: [],
            template_html_content: "",
            img_list: [],
            timer: '48',
            needCheck: true,
            downPath: '',
            showSecond: false
        }
    },
    created() {
        that = this;
        this.timer = Date.parse(new Date());
    },
    methods: {
        backOut() {
            this.showSecond = false
            this.$emit('titleSync', false)
        },
        openIt(e) {
            this.showSecond = true
            this.img_list = e.contract_imgs || []
            this.downPath = e.contract_path
            this.needId = e.id

            let a = e.partya_template_cg_arr || []
            let b = e.partyb_template_cg_arr || []
            this.components_arr = a.concat(b) || []
        },
        resetWidth() {
            this.titleSync.arr.participant.forEach(function (v, k, arr) {
                if (v.position_pagenum > 0) {
                    v.positionY = Number(v.positionY) + ((v.position_pagenum - 1) * 1147)
                }
                if (v.positionfirm_pagenum > 0) {
                    v.positionfirmY = Number(v.positionfirmY) + ((v.positionfirm_pagenum - 1) * 1147)
                }
                if (arr[k].yinzhang != null && arr[k].yinzhang != "") {
                    let img = new Image();
                    img.src = arr[k].yinzhang;
                    if (img.complete) {
                        arr[k].yinzhang_width = img.width / 3;
                        arr[k].yinzhang_height = img.height / 3;
                    } else {
                        // 加载完成执行
                        img.onload = function () {
                            arr[k].yinzhang_width = img.width / 3;
                            arr[k].yinzhang_height = img.height / 3;
                        };
                    }
                }
            })
            setInterval(function () {
                that.list = that.titleSync.arr.participant;
            }, 100)
        },
        resetWidthElse() {
            this.titleSync.arr.participant.forEach(function (v, k, arr) {
                if (arr[k].yinzhang != null && arr[k].yinzhang != "") {
                    let img = new Image();
                    img.src = arr[k].yinzhang;
                    if (img.complete) {
                        arr[k].yinzhang_width = img.width / 3;
                        arr[k].yinzhang_height = img.height / 3;
                    } else {
                        // 加载完成执行
                        img.onload = function () {
                            arr[k].yinzhang_width = img.width / 3;
                            arr[k].yinzhang_height = img.height / 3;
                        };
                    }
                }
            })
            setInterval(function () {
                that.list = that.titleSync.arr.participant;
            }, 100)
        },
        download() {
            if (!that.needCheck) {
                return that.$Message.error('请勿重复下载')
            }
            that.$Message.loading({
                content: '生成中...',
                duration: 0
            })
            if (this.downPath) {
                that.$Message.destroy()
                window.open(this.downPath)
                that.needCheck = true
                return
            }
            that.needCheck = false
            getpdf({ id: this.needId }).then(res => {
                that.$Message.destroy()
                window.open(res.data)
                that.needCheck = true
            }).catch(res => {
                console.log(res)
                that.needCheck = true
            })
        }
    }
}

</script>

<style scoped>
.partya {
    border: 2px dashed #d9534f;
    /* background-color: rgba(22, 91, 165, 0.1); */
}

.partyb {
    border: 2px dashed #165ba5;
    /* background-color: rgba(217, 83, 79, 0.1); */
}

.dabox {
    width: 100%;
    display: flex;
}

.leftbox {
    width: 150px;
    background: white;
    position: fixed;
    height: 100vh;
    text-align: center;
    padding-top: 100px;

    /* width: 200px;
    background: white;
    position: fixed;
    height: 100vh; */
}

.right-box {
    flex: 1;
}

.buttonCss {
    margin-top: 20px;
}

.bg-img {
    width: 800px;
    margin: auto;
    background: white;
    /* margin-bottom: 2px; */
    box-shadow: 0 10px 10px rgba(0, 0, 0, .3);
    height: 1132px;
    border-bottom: 1px solid #8a8f97;
    box-sizing: border-box;
}

.bg-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: auto;
    display: inline-block;
}
</style>
<style>
.new-more tr {
    height: 30px;

}

.new-more table {
    width: 100%;
    border: 1px solid #777777;
}

.new-more td,
.new-more th {
    border: 1px solid #777777;
}

.MsoNormalTable {
    margin-left: unset !important;
}
</style>
